// extracted by mini-css-extract-plugin
export default {"loaderCont":"Loader_loaderCont__gn-r4","rotate":"Loader_rotate__e-Mev"};